// extracted by mini-css-extract-plugin
export default {"main":"bb8faf4bf0","tit":"_5f732533f4","maintitle":"bc0f7eec9f","ylw":"dd6db99c60","white":"d24c49f96f","mv_title":"d8fed6700d","mv_nc":"b4a10e6e74","mv_in":"_6f51948a50"};